<template>
  <v-snackbar v-model="snackbar" :color="variant" multi-line :timeout="timeout" right top>
    <v-container fluid>
      <v-row v-if="!showList">
        <v-col>{{ message }}</v-col>
      </v-row>
      <v-list v-if="showList" class="list-error">
        <v-list-item v-for="item in items" :key="item.index" class="list-tile">
          <v-list-item-content>
            <v-list-item-title v-text="item.msg" class="alert-text text-wrap"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-container>
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
    <v-btn text @click="snackbar = false">
      <v-icon>mdi-close</v-icon>
    </v-btn>
        </v-btn>
      </template>
  </v-snackbar>
</template>

<script>
import { EventBus } from '@/router/bus'

export default {
  data () {
    return {
      snackbar: false,
      message: '',
      variant: 'info',
      timeout: 15000,
      showList: false,
      showScroll: false,
      items: []
    }
  },
  created () {
    EventBus.$on('alert', (data) => {
      this.items = []
      this.showList = false
      this.variant = data.variant
      this.message = data.message
      this.snackbar = true
      this.timeout = 15000
      // this.link = data.link
      // this.linkDescription = data.linkDescription
      if (data.errors && data.errors.length > 0) {
        this.timeout = 0
        this.items = data.errors
        this.showScroll = this.items.length > 3
        this.showList = true
      }
    })

    EventBus.$on('notification-close', () => {
      this.disposeNotification()
    })
  },
  methods: {
    disposeNotification () {
      this.snackbar = false
      this.items = []
    }
  }
}
</script>
<style lang="scss" type="text/scss" scoped>

  @import '~@/assets/scss/variables.scss';

  .alert-top {
    position: absolute;
    top: 64px;
    z-index: 99;
    border-radius: 0;
    margin-left: 5px;
    width: calc(100% - 10px);
  }

  .mainContainer {
    background-color:transparent;
    padding-top: 2px;
    margin-top: 2px;
    width: 120vh;
  }

  .messageArea {
    min-width:93%;
    max-width:93%;
    padding-top:2%;
    background: transparent;
    color: white;
    padding-left:-100px;
    margin-top:-10px;
    margin-bottom: 2%;
  }

  .closeArea {
    min-width:7%;
    max-width:7%;
    padding-top:7px;
    background: transparent;
    color: white;
    margin-top:-16px;
  }

  .closeIcon {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0;
    margin: 0;
  }

  .topContainer {
    background-color: transparent;
    min-width: calc(100%);
  }

  .list-error {
    background-color: var(--v-error-base) !important;
  }

  .list-error-long {
    background-color: var(--v-error-base) !important;
    height:250px;
    overflow-y: scroll;
  }

  .list-tile {
    background-color: var(--v-error-base) !important;
  }

  .alert-text {
    font-size: 14px;
    color: rgb(250, 250, 250);
    padding-right: 10px;
    min-width: 93%;
  }

  .alert-pointer {
    margin-left: -10px;
    max-width: 7%;
  }

  .alert-pointer-icon {
    color: white;
  }

</style>
